// extracted by mini-css-extract-plugin
export default {"TOP":"ProductPage_TOP__81b7-"};